import React from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class EditAnswerForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            text: '',
            quote: ''
        }
    }

    componentDidMount() {
        if (this.props.answer)
            this.setState(this.props.answer)
    }

    componentDidUpdate(prevProps) {
        if (prevProps.answer !== this.props.answer) {
            this.setState(this.props.answer)
            this.textField.focus()
        }
    }

    onTextRef = (field) => {
        if (this.props.answer)
            field.focus()
        this.textField = field
    }

    reset() {
        const currentState = this.state
        const newState = { ...currentState }
        for (let p in currentState)
            newState[p] = ''
        this.setState(newState)
    }

    focusInput = (props) => <Input ref={this.onTextRef} {...props} />

    handleChange = (e, { name, value }) => this.setState({ [name]: value })
    handleCancel = (e) => {
        e.preventDefault()
        this.reset()
        this.props.onCancel()
    }

    onSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()
        if (this.props.onSubmit)
            this.props.onSubmit(this.state)
        this.reset()
    }

    render() {
        const { text, quote } = this.state

        return (
            <Form onSubmit={this.onSubmit}>
                <Form.Group widths='equal'>
                    <Form.Input required 
                        label='Risposta' 
                        name='text' 
                        value={text}   
                        onChange={this.handleChange}
                        control={this.focusInput} />
                    <Form.Input 
                        label='Quota' 
                        name='quote' 
                        type='number' 
                        value={quote} 
                        onChange={this.handleChange} 
                        step='any'
                        placeholder='black answer' />
                </Form.Group>
                <Form.Group>
                    <Form.Button type='submit'>Salva</Form.Button>
                    <Form.Button onClick={this.handleCancel}>Annulla</Form.Button>
                </Form.Group>
            </Form>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/EditAnswerForm.js